module.exports = __webpack_public_path__ + "static/media/gr5-quiz.7e7a71f4.pdf";